<template>
  <a-steps
  direction="vertical"
  :current="form.data.length-1"
  >
    <a-step v-for = "item in form.data" :key="item.ftime" :title="moment(item.ftime).format('YYYY-MM-DD HH:mm:ss')" :description="item.context">
    </a-step>
  </a-steps>

</template>

<script>

import moment from 'moment';

import {
  _queryOrderExpressTrack
} from '@/api/orderExpressApi';

async function getOrderExpressInfo() {
  const result = await _queryOrderExpressTrack(this.goodsOrderExpressId);
  if (result) {
    this.form.data = result.data.reverse();
  } else {
    this.$message.error('获取失败');
  }
}

export default {
  name: 'OrderExpressTrack',
  props: {
    goodsOrderExpressId: String,
  },
  methods: {
    getOrderExpressInfo,
  },
  data() {
    return {
      moment: moment,
      form: {
        data: [],
      }
    };
  },
  created() {
    if (this.goodsOrderExpressId) {
      this.getOrderExpressInfo();
    }
  }
};
</script>

<style>

</style>
